module.exports = __webpack_public_path__ + "media/images/icon_search_license-975c440870ff7d865ac57fca74593d69.png";